import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Col, Row, Skeleton } from "antd";
import {
  CalendarComp,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
  TimePickerInput,
} from "../../../../components";
import TaskList from "../Checklist/TaskList/TaskList";
import styles from "./Timeline.module.css";
import { CheckListMiddleware } from "../../../../Store/Middlewares/CheckListMiddleware";
import moment from "moment";
import Modal from "../../../../components/modal/Modal";
import ShareChecklistModal from "../../EventsCalendar/ShareChecklistModal/ShareCheckListModal";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { MdDelete, MdEdit } from "react-icons/md";
import DraggableList from "react-draggable-list";
import { getEventTimeline } from "../../../../Store/Actions/EventAction";
import { LuDownload } from "react-icons/lu";
import dayjs from "dayjs";

const Timeline = () => {
  const user = useSelector((state) => state.AuthReducer.user.role);
  const Timeline = useSelector((state) => state.EventReducer.Timeline);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setloading] = useState(false);
  // const [checklistData, setChecklistData] = useState([]);
  // const [checklisId, setChecklisId] = useState();
  const [title, setTitle] = useState();
  const [description, setDescription] = useState();
  const [time, setTime] = useState();
  // const [selectedDate, setSelectedDate] = useState(
  //   moment(new Date()).format("YYYY-MM-DD")
  // );
  // const [markedDate, setMarkedDate] = useState([]);

  const { state } = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventMiddleware.getTimeline(state?.eventData?.id));
  }, []);

  // const getCalendarData = (date) => {
  //   let dates = markedDate?.map(function (x) {
  //     return moment(x).format("YYYY-MM-DD");
  //   });
  //   let selectedDate = moment(date).format("YYYY-MM-DD");
  //   let exist = dates.includes(selectedDate) ? true : false;

  //   if (exist) {
  //     setloading(true);
  //     let eventData = {
  //       id: state?.eventData?.id,
  //       date: selectedDate,
  //       user_role: user,
  //     };
  //     dispatch(CheckListMiddleware.getCalendarCheckList(eventData))
  //       .then((data) => {
  //         console.log("data==========================", data);
  //         setChecklistData(data?.checklists);
  //         setMarkedDate(data?.dates ? data?.dates : []);
  //         setSelectedDate(selectedDate);
  //         setloading(false);
  //       })
  //       .catch(() => setloading(false));
  //   }
  // };
  const onCreateTimeline = () => {
    if (!title ) {
      dispatch(
        showAlert({ type: "error", message: "Please enter title" })
      );
      return;
    } else {
      // setopenModal(false);
      let eventData = {
        event_id: state?.eventData?.id,
        title,
        description,
        time: time ?  moment(time.$d).format("HH:mm") : null,
        id: isEdit?.id ? isEdit?.id : "",
      };
      // console.log("sadfasfsdfdfghfghfgjkgkjhlyrtuyyti", eventData);
      dispatch(EventMiddleware.createTimeline(eventData))
        .then(() => {
          setTitle("");
          setDescription("");
          setIsModalOpen(false);
        })
        .catch((err) => {
          setIsModalOpen(false);
          console.log(err?.response?.data?.message)
          ;
        });
    }
  };

  const delTimeline = (id) => {
    dispatch(
      EventMiddleware.deleteTimeline({ event_id: state?.eventData?.id, id: id })
    );
  };

  const printDocument = () => {
    dispatch(EventMiddleware.generateTimelinePdf(state?.eventData?.id)).then(
      (response) => {
        // const resp = await axios.get(response.attachment, {
        //   headers: {
        //     "Access-Control-Allow-Origin": "*",
        //   },
        // });
        // resp.blob().then((blob) => {
        // Creating new object of PDF file

        // Setting various property values
        const pdfUrl = `https://www.bestdayever.me/api/downloadFile?path=${response.attachment}`;

        const link = document.createElement("a");
        link.href = pdfUrl;
        // link.target = "_blank";
        link.download = "Event Timeline"; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // saveAs(response?.attachment, `${response.title}.pdf`);
      }
    );
  };

  console.log("checklistData", Timeline);

  // const onPressSend = (vendorID) => {
  //   // setModal(false);
  //   let checkListData = {
  //     checklist_id: checklisId,
  //     event_id: state?.eventData?.id,
  //     vendor_id: vendorID,
  //   };
  //   dispatch(CheckListMiddleware.sendCheckList(checkListData));
  //   // .then(() =>{})
  //   // .catch((err) => console.log(err));
  // };
  return (
    <Row>
      {/* <Col xs={24} lg={12}>
        <CalendarComp markedDate={markedDate} getLoanData={getCalendarData} />
      </Col> */}
      <Col style={{ width: "100%" }}>
        <Row className={styles.headRow}>
          <TextComponent textClass={styles.checklistTitle}>
            Timeline
          </TextComponent>
          <div className={styles.createBtn}>
            <LuDownload
              className={styles.icon}
              size={35}
              onClick={printDocument}
            />
            <SubmitButton
              // btnClass={styles.createBtn}
              title="Create Timeline"
              onClick={() => {
                setIsEdit();
                setTitle("");
                setDescription("");
                setIsModalOpen(true);
              }}
            />
          </div>
        </Row>
        <Skeleton loading={loading}>
          {/* <TaskList
            tasks={checklistData}
            getDataOnCkeck={() => getCalendarData(selectedDate)}
          /> */}
          <Row className={styles.taskRow} style={{position: 'relative', zIndex: 1}}>
            <DraggableList
              // className={styles.planningItemsList}
              list={Timeline?.length > 0 ? Timeline : []}
              itemKey="id"
              onMoveEnd={(newList) => {
                dispatch(getEventTimeline(newList));
                dispatch(
                  EventMiddleware.sorteTimeline(newList, state?.eventData?.id)
                );
              }}
              template={({ item, dragHandleProps, itemSelected }) => {
                // const scale = itemSelected * 0.05 + 1;
                const shadow = itemSelected * 15 + 1;
                return (
                  <Row
                    className={styles.taskBox}
                    {...dragHandleProps}
                    style={{
                      // transform: `scale(${scale})`,
                      boxShadow: `rgba(0, 0, 0, 0.3) 0px ${shadow}px ${
                        2 * shadow
                      }px 0px`,
                    }}
                  >
                    <Col className={styles.leftCol}>
                      {/* <TextComponent>Due: Today, Sunday 1</TextComponent> */}
                      <TextComponent textClass={styles.taskTitle}>
                        {item?.title}
                      </TextComponent>
                      <TextComponent textClass={styles.description}>
                        {item?.description == "null" ? "" : item?.description}
                      </TextComponent>
                      <TextComponent textClass={styles.date}>
                        {item?.time ?  moment(item?.time,   "HHmmss").format("hh:mm A") : ''}
                      </TextComponent>
                    </Col>
                    <Col style={{ width: "50px" }}>
                      <MdEdit
                        cursor={"pointer"}
                        size={25}
                        color="var(--primary-color)"
                        onClick={() => {
                          setIsEdit(item);
                          setTitle(item?.title);
                          console.log(dayjs(item?.time));
                          setTime(item?.time ? dayjs("Thu Jul 25 2024 "+item?.time) : null);
                          setDescription(item?.description);
                          setIsModalOpen(true);
                        }}
                      />
                      <MdDelete
                        cursor={"pointer"}
                        size={25}
                        color="var(--primary-color)"
                        onClick={() => delTimeline(item.id)}
                      />
                    </Col>
                  </Row>
                );
              }}
            />
            {/* {Timeline?.map((item) => (
              
            ))} */}
          </Row>
        </Skeleton>
      </Col>
      {/* <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        pinkBg={true}
      >
        <ShareChecklistModal onPressSend={onPressSend} />
      </Modal> */}
      {isModalOpen && (
        <Modal
          grayBg
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          className={styles.modal}
          onClose={() => {
            setTime(null);
          }}
          closable
        >
          <TextComponent textClass={styles.modalHeading}>
            {isEdit ? "Edit" : "Create"} Timeline
          </TextComponent>
          <div className={styles.inputs}>
            <InputField
              label="Title"
              placeholder={"Enter Title"}
              value={title}
              // disabled
              onChange={(e) => setTitle(e.target.value)}
            />
            <TimePickerInput
              label="Time"
              // icon={<ClockIcon size={25} />}
              value={time}
              onChange={(e) => setTime(e)}
            />
            <TextareaField
              label="Description"
              placeholder={"Description"}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <SubmitButton
            title={`${isEdit ? "Edit" : "Create"} Timeline`}
            onClick={onCreateTimeline}
          />
        </Modal>
      )}
    </Row>
  );
};

export default Timeline;
